import { LocalStorageKeys } from "@/common/browserStorage/constants";
import { UTM_SOURCE, utmKeysMap, UtmProps } from "@/common/utm/constants";

export const utmController = () => {
  try {
    try {
      const uriSearchParam = location.search.substring(1);
      const hasSource = uriSearchParam?.includes(UTM_SOURCE);

      if (hasSource) {
        const jsonFormat = `{"${uriSearchParam
          .replace(/=/g, '":"')
          .replace(/&/g, '","')}"}`;

        const utmUriParams = JSON.parse(jsonFormat, (key, value) =>
          key === "" ? value : decodeURIComponent(value),
        );
        const utmSource: string | undefined = utmUriParams?.[UTM_SOURCE];
        const utmProps = utmSource
          ? utmKeysMap[utmSource?.toLowerCase()]
          : null;

        if (utmSource && utmProps) {
          const utm: UtmProps = {
            source: utmSource,
            click_id: utmUriParams[utmProps["click_id"]] || "",
            web_id: utmUriParams[utmProps["web_id"]] || "",
            addons: utmUriParams[utmProps["addons"]] || "",
          };

          if (utmUriParams["contact_id"]) {
            utm.contact_id = utmUriParams["contact_id"];
          }

          if (utmSource.includes("sms_bazaAidana")) {
            utm.click_id = "utm_campaign";
            utm.web_id = "utm_medium";
          }

          localStorage.removeItem(LocalStorageKeys.Utm);
          localStorage.setItem(LocalStorageKeys.Utm, JSON.stringify(utm));
        }
      }
    } catch {
      localStorage.removeItem(LocalStorageKeys.Utm);
    }
  } catch (error) {
    throw Error(JSON.stringify(error));
  }
};
